<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()" class="back-btn">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Resúmenes</span>
</mat-toolbar>

<main class="summary-page">
  <section class="summary-hero">
    <div class="summary-hero__icon">
      <mat-icon>summarize</mat-icon>
    </div>
    <div>
      <h1>Resúmenes por email</h1>
      <p>Genera el contenido con IA, revísalo y decide cuándo enviarlo.</p>
    </div>
  </section>

  <section class="summary-card">
    <div class="summary-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        [class.active]="mode === 'round'"
        [attr.aria-selected]="mode === 'round'"
        (click)="setMode('round')"
      >
        <mat-icon>emoji_events</mat-icon>
        Rondas
      </button>
      <button
        type="button"
        role="tab"
        [class.active]="mode === 'match_day'"
        [attr.aria-selected]="mode === 'match_day'"
        (click)="setMode('match_day')"
      >
        <mat-icon>today</mat-icon>
        Jornadas
      </button>
    </div>

    <div class="section-label">
      {{ mode === "round" ? "Ronda" : "Jornada" }}
    </div>
    <mat-form-field appearance="outline" class="round-field">
      <mat-label>
        {{ mode === "round" ? "Selecciona una ronda" : "Selecciona una jornada" }}
      </mat-label>
      <mat-select
        [(ngModel)]="selectedId"
        (selectionChange)="onSelectionChange()"
      >
        @if (mode === "round") {
          @for (round of rounds; track round.name) {
            <mat-option [value]="round.name">{{ round.title }}</mat-option>
          }
        } @else {
          @for (day of matchDays; track day.dayId) {
            <mat-option [value]="day.dayId">
              {{ day.title }} · {{ day.finishedMatches }}/{{ day.totalMatches }}
            </mat-option>
          }
        }
      </mat-select>
    </mat-form-field>

    @if (mode === "match_day") {
      <div class="section-label">Clasificación</div>
      <mat-form-field appearance="outline" class="round-field">
        <mat-label>Resumen general o de grupo</mat-label>
        <mat-select
          [(ngModel)]="selectedGroupId"
          (selectionChange)="onGroupChange()"
        >
          <mat-option value="">Clasificación general</mat-option>
          @for (group of groups; track group._id) {
            <mat-option [value]="group._id">
              {{ group.shield || "🏆" }} {{ group.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (mode === "match_day" && selectedDay) {
      <div
        class="closure-indicator"
        [class.closure-indicator--closed]="selectedDay.closed"
      >
        <mat-icon>{{ selectedDay.closed ? "lock" : "schedule" }}</mat-icon>
        {{
          selectedDay.closed
            ? "Jornada cerrada"
            : "Aún quedan partidos por finalizar"
        }}
      </div>
    }

    <div class="status-panel">
      <div class="status-panel__header">
        <span class="section-label">Estado</span>
        <button
          mat-icon-button
          type="button"
          aria-label="Actualizar estado"
          [disabled]="loadingStatus || !selectedId"
          (click)="loadStatus()"
        >
          <mat-icon [class.spin]="loadingStatus">refresh</mat-icon>
        </button>
      </div>

      @if (summary && !loadingStatus) {
        <div class="status-row">
          <span
            class="status-badge"
            [ngClass]="'status-badge--' + summary.status"
          >
            <mat-icon>
              @switch (summary.status) {
                @case ("sent") {
                  mark_email_read
                }
                @case ("generated") {
                  task_alt
                }
                @case ("pending") {
                  schedule
                }
                @case ("error") {
                  error_outline
                }
                @default {
                  draft
                }
              }
            </mat-icon>
            {{ statusLabel }}
          </span>

          @if (summary.sentAt) {
            <span class="status-date">
              Enviado {{ summary.sentAt | date: "d MMM y, HH:mm" }}
            </span>
          } @else if (summary.generatedAt) {
            <span class="status-date">
              Generado {{ summary.generatedAt | date: "d MMM y, HH:mm" }}
            </span>
          }
        </div>

        @if (summary.error) {
          <div class="error-message">
            <mat-icon>warning</mat-icon>
            <span>{{ summary.error }}</span>
          </div>
        }

        @if (summary.data) {
          <div class="summary-metrics">
            <div class="metric">
              <span class="metric__value">
                {{ summary.data.finishedMatches ?? 0 }}/{{
                  summary.data.totalMatches ?? 0
                }}
              </span>
              <span class="metric__label">Partidos finalizados</span>
            </div>
            <div class="metric">
              <span class="metric__value">
                {{ summary.data.leader?.userName || "—" }}
              </span>
              <span class="metric__label">Líder</span>
            </div>
            <div class="metric">
              <span class="metric__value">
                {{ summary.data.snipers?.[0]?.userName || "—" }}
              </span>
              <span class="metric__label">Mejor francotirador</span>
            </div>
          </div>
        }
      } @else {
        <div class="status-loading">
          @if (loadingStatus) {
            <mat-spinner diameter="24"></mat-spinner>
            <span>Consultando estado...</span>
          } @else {
            <span>No se ha podido consultar el estado.</span>
          }
        </div>
      }
    </div>

    @if (summary?.data?.narrative; as narrative) {
      <div class="narrative-preview">
        <div class="section-label">
          Texto generado con IA
          @if (selectedGroup) {
            · {{ selectedGroup.name }}
          }
        </div>
        <h2>{{ narrative.headline }}</h2>
        <p>{{ narrative.intro }}</p>
        <ul>
          @for (highlight of narrative.highlights; track highlight) {
            <li>{{ highlight }}</li>
          }
        </ul>
        @if (narrative.overallConclusions?.length) {
          <h3>Conclusiones de la clasificación</h3>
          <ul>
            @for (
              conclusion of narrative.overallConclusions;
              track conclusion
            ) {
              <li>{{ conclusion }}</li>
            }
          </ul>
        }
        @if (narrative.playfulSetbacks?.length) {
          <h3>El lado más sufrido</h3>
          <ul>
            @for (setback of narrative.playfulSetbacks; track setback) {
              <li>{{ setback }}</li>
            }
          </ul>
        }
        <p>{{ narrative.closing }}</p>
      </div>
    }

    <div class="summary-notice">
      <mat-icon>info</mat-icon>
      <p>
        La generación recopila estadísticas y crea el texto con IA, pero
        <strong>no envía ningún email</strong>. El envío se realiza en un paso
        independiente.
      </p>
    </div>

    <div class="actions">
      <button
        mat-flat-button
        class="primary-action"
        [disabled]="!selectedId"
        (click)="confirmGenerate()"
      >
        <mat-icon>{{ hasGeneratedSummary ? "refresh" : "auto_awesome" }}</mat-icon>
        {{ hasGeneratedSummary ? "Regenerar" : "Generar con IA" }}
      </button>

      @if (mode === "match_day") {
        <button
          mat-stroked-button
          class="bulk-action"
          [disabled]="!selectedId || groups.length === 0"
          (click)="confirmGenerateAll()"
        >
          <mat-icon>auto_awesome</mat-icon>
          Generar todos
        </button>
      }

      <button
        mat-stroked-button
        class="send-action"
        [disabled]="!canSend"
        (click)="confirmSend()"
      >
        <mat-icon>outgoing_mail</mat-icon>
        {{ summary?.status === "sent" ? "Reenviar" : "Enviar" }}
      </button>
    </div>
  </section>
</main>

<block-ui></block-ui>
